
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createbankstatements } from '../../api/bankstatements.api'
import {getAllbalanceproductfile } from '../../api/balanceproductfile.api'

import './dashboardlistadoproductos.scss';






const Pdashboardlistadoproductos = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyendpoint_6560bec70eebbe3b7e300943, setLoftyEndpoint_6560bec70eebbe3b7e300943] = useState([]);
	
useEffect(() => {
		const loftyHandleData = async () => {
			const loftyres_6560bec70eebbe3b7e300943 = await getAllbalanceproductfile({ token: loftytoken || 'asdsa' });
			setLoftyEndpoint_6560bec70eebbe3b7e300943(loftyres_6560bec70eebbe3b7e300943.data);
		}
		loftyHandleData();
	}, []);



  
  
  
  

  if (!loftytoken) {
		return (<div>Requiere Autenticación</div>);
	}

  return (
    <div id="id654aa4cfc239522da2e3ba28" >

      <div id="fgfg" className="">
      
      <div id="iifg" className="gjs-row ">
      
      <div id="ig49" className="gjs-cell ">
      
      <div id="i99szh" className="">
      
        <a
          target=""
          className=""
          id="i9ymbj"
          href="#"
        >
          
      <img
        className=""
        id="i1d1f1"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkr0oo7y.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="iyxmw" className="">
      
        <a
          target=""
          className=""
          id="imqh5"
          href={`/dashboard`}
        >
          
      <div id="i0uip" className="itemnavigation ">
      
      <div className="" id="ij9fr">
        <>Inicio</>
      </div>
      
      </div>
      
        </a>
        
        <a
          target=""
          className=""
          id="iiwfn"
          href={`/dashboard/productos`}
        >
          
      <div id="i51wa" className="itemnavigationdefault ">
      
      <div className="" id="ib3yz">
        <>Mis Productos</>
      </div>
      
      </div>
      
        <a
          target=""
          className=""
          id="iia13"
          href="#"
        >
          
      <div id="ihupb" className="itemnavigation ">
      
      <div className="" id="irvrr">
        <>Configuraciones</>
      </div>
      
      </div>
      
        </a>
        
        </a>
        
      </div>
      
      <div id="igr3j" className="">
      
      <button
        type=""
        name=""
        id="i0k7v"
        className="buttoniniciosesion "
        onClick={async () => {
		deleteLoftytokenApp();
		window.location.href = '/signin';
}}

      >
      
      <div className="" id="isj6f">
        <><br />          Cerrar Sesion<br />        </>
      </div>
      
      </button>
      
      </div>
      
      </div>
      
      <div id="io5ng" className="gjs-cell ">
      
      <div id="ipm2s" className="">
      
      <div className="" id="if76p">
        <>Productos</>
      </div>
      
      </div>
      
      <div id="i2c23" className="">
      
      <div id="iw7af" className="">
      
      <div id="i16zi" className="">
      
        <a
          target=""
          className="buttoniniciosesion "
          id="io5do"
          href="/dashboard/productos/agregar"
        >
          
    <div id="iqbei" className="">
    <>Agregar Producto</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="ix48j" className="">
      
      <div id="ir7jg" className="itemproducto ">
      
      <div className="" id="iexft">
        <>Etiqueta</>
      </div>
      
      </div>
      
      <div id="i8ugf" className="itemproducto ">
      
      <div className="" id="idepg">
        <>Balance</>
      </div>
      
      </div>
      
      <div id="ihq9j" className="itemproducto ">
      
      <div className="" id="ik4wg">
        <>Acción</>
      </div>
      
      </div>
      
      </div>
      
        <div id="i2waf" className="">
        
          {
            loftyendpoint_6560bec70eebbe3b7e300943.map((loftyitem) => (
              <div key={loftyitem._id} className="" id="izsvi">
                
        <div className="" id="iprma">
          
          <div className="" id="i5bcg">
            {loftyitem.tag}
          </div>
          
        </div>
        
        <div className="" id="itg36">
          
          <div className="" id="">
            {loftyitem.amount}
          </div>
          
        </div>
        
        <a
          target=""
          className=""
          id="ip7e1"
          href="#"
        >
          
    <div id="izhei" className="">
    <>Ver más</>
    </div>
    
        </a>
        
              </div>
            ))
          }
          
        </div>
        
      </div>
      
        <div className="" id="imhtl">
          
        </div>
        
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pdashboardlistadoproductos);
  